import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type StateService from 'garaje/services/state';
import { Permission } from 'garaje/utils/ui-permissions';

export default class SensitiveFieldAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare state: StateService;

  // MPB is supported for Visitors Enterprise, so the entitlement is per-location: read the
  // scope-aware `state.features` (resolves to the location record under MPB), not the company aggregate.
  get canManage(): boolean {
    if (!this.state.features?.canAccessSensitiveFields) return false;
    return this.hasPermission(Permission.VISITORS_SIGN_IN_FIELDS_MANAGE_SENSITIVE);
  }

  private hasPermission(permission: Permission): boolean {
    return (
      this.authz.hasPermissionAtCurrentCompany(permission) || this.authz.hasPermissionAtCurrentLocation(permission)
    );
  }
}
